import {AssignAccessAdministrationUserRoleBody} from "@project/sdk/access-administration/zod";
import type {z} from "zod";

export const assignUserRoleFormSchema = AssignAccessAdministrationUserRoleBody;
export type AssignUserRoleFormPayload = z.output<typeof assignUserRoleFormSchema>;
export const draftAssignUserRoleFormSchema = assignUserRoleFormSchema.partial();
export type DraftAssignUserRoleFormPayload = z.output<typeof draftAssignUserRoleFormSchema>;
